<div id="issue-report-form-control-container">
    <div id="issue-report-form-tab">
        <div class="modal-header">
            <span class="fas fa-bug handle"> </span>
            <h5 class="modal-title" [translate]="'bug_report_form.title'"></h5>
        </div>
        <div class="modal-body">
            <div class="mt-3">
                <div [formGroup]="bugReportForm">
                    <div class="floating-label">
                        <input [formControlName]="'name'" type="text" class="input" [attr.placeholder]="'bug_report_form.name' | translate" autocomplete="off" />
                        <label class="inner-label" [translate]="'bug_report_form.name'"></label>
                        <div class="icon">
                            <span class="fas fa-heading"></span>
                        </div>
                        <field-error-display-control [displayError]="bugReportForm.showFieldError('name')" [errorMsg]="bugReportForm.getErrorMessageHtml('name')"> </field-error-display-control>
                    </div>
                    <div class="floating-label floating-label-textarea-6rows">
                        <textarea [formControlName]="'description'" class="textarea-resize-none" rows="6" [attr.placeholder]="'bug_report_form.description' | translate" autocomplete="off"></textarea>
                        <label class="inner-label" [translate]="'bug_report_form.description'"></label>
                        <div class="icon">
                            <span class="fas fa-align-left"></span>
                        </div>
                        <field-error-display-control [displayError]="bugReportForm.showFieldError('description')" [errorMsg]="bugReportForm.getErrorMessageHtml('description')"> </field-error-display-control>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button-control buttonType="button" themeColor="primary" [buttonText]="'bug_report_form.send'" [onClickAsync]="submitBugReport"> </button-control>
        </div>
    </div>
</div>
